















































































import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class AnimatedButton extends Vue {
  @Prop({ type: String, default: "Button" }) label!: string;
  @Prop({ type: String, default: "" }) label_sm!: string;
  @Prop({ type: String, default: "mdi-arrow-down-right" }) icon!: string;
  @Prop({ type: Boolean, default: false }) large!: boolean;

  onClick() {
    this.$emit('onClick:animatedButton');
  }
}
